/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTokenStore } from "../Zustand/TokenStore";
// Assuming Action is imported from types file

type ActionName =
  | "List"
  | "Add"
  | "Update"
  | "Delete"
  | "View"
  | "Print"
  | "Export"
  | "Approval"
  | "Transfer"
  | "Cancel";

type Permissions = {
  [key in ActionName]: {
    status: boolean;
    id: number;
  };
};

export const usePagePermissions = (pageId: number): Permissions => {
  const [permissions, setPermissions] = useState<Permissions>({
    List: { status: false, id: 0 },
    Add: { status: false, id: 0 },
    Update: { status: false, id: 0 },
    Delete: { status: false, id: 0 },
    View: { status: false, id: 0 },
    Print: { status: false, id: 0 },
    Export: { status: false, id: 0 },
    Approval: { status: false, id: 0 },
    Transfer: { status: false, id: 0 },
    Cancel: { status: false, id: 0 },
  });
  const authData = useTokenStore.getState().AuthData;

  useEffect(() => {
    // Find the page across all modules by pageId
    let foundPage = null;
    for (const module of authData?.Modules || []) {
      foundPage = module.Pages.find((page) => page.Page_Id === pageId);
      if (foundPage) break;
    }

    // If the page is found, update permissions
    if (foundPage) {
      const updatedPermissions = { ...permissions };
      foundPage.Permissions.Actions.forEach((action) => {
        if (action.ActionName in updatedPermissions) {
          updatedPermissions[action.ActionName as ActionName] = {
            status: action.Status,
            id: action.ActionId,
          };
        }
      });
      setPermissions(updatedPermissions);
    }
  }, [authData, pageId]);

  return permissions;
};
